angular.module('impactx.electronicdownload').controller('ElectronicDownloadAccessLogCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'themeFactory',
    ElectronicDownloadAccessLogController]);

function ElectronicDownloadAccessLogController($scope, dataGen, $mdDialog, themeFactory) {
    var self = this;
    $scope.trns = self.trns;
    $scope.theme = themeFactory.getTheme();

    dataGen.getData($scope, {eddId: self.eddId}, '/electronicdownload/accesslog');

    self.close = function () {
        $mdDialog.cancel();
    };
}